import loadable from '@loadable/component'

export default [
  {
    path: '/NewUserJoinGuide/task',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewUserJoinGuide-task" */ '~/pages/NewUserJoinGuide/pages/task'
        )
    ),
  },
  {
    path: '/NewUserJoinGuide/memberList/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewUserJoinGuide-memberList" */ '~/pages/NewUserJoinGuide/pages/memberList'
        )
    ),
  },
  {
    // 召集令
    path: '/call-action',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CallActionPage-index" */ '~/pages/NewUserJoinGuide/pages/CallActionPage'
        )
    ),
  },
  {
    // 工作详情
    path: '/call-action/work',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CallActionWork-index" */ '~/pages/NewUserJoinGuide/pages/CallActionWork'
        )
    ),
  },
  {
    // 主播管理-活跃报告
    path: '/anchor-manage/activity-report',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ActivityReport-index" */ '~/pages/NewUserJoinGuide/pages/ActivityReport'
        )
    ),
  },
  {
    path: '/NewUserActive',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewUserActive" */ '~/pages/NewUserJoinGuide/pages/active'
        )
    ),
  },
  {
    path: '/NewUserHalfRank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewUserHalfRank" */ '~/pages/NewUserJoinGuide/pages/halfrank'
        )
    ),
  },
]
